import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { appInstallMutate } from 'queries';
import { reducer } from 'actions/registry/fetch-installed-apps';
import { permissionsToRegistry } from 'actions/registry/update-permissions';
import { savePermissions } from 'actions/gallery';
import App from 'models/app';

export default new AsyncActionHandler({
  name: 'mark_app_installed',
  stateProp: 'markAppInstalled',
  handler: (id) => async (dispatch, getState) => {
    const state = getState();

    const {
      deviceInfo: { wireId }
    } = state.gallery;

    const app = App.selectFromState(id, state);

    let permissions;
    if (app.grantedPermissions) {
      permissions = permissionsToRegistry(app.grantedPermissions);
    }

    const { data: response } = await apollo.mutate({
      mutation: appInstallMutate,
      variables: {
        id,
        permissions,
        wireId
      }
    });

    // Clear client permissions for app since they are persisted
    // on the server now
    dispatch(savePermissions({ appId: id, grantedPermissions: {} }));

    return {
      entries: response.installApp
    };
  },
  reduce: reducer
});
